export const Currency = () => {
  return (
    <svg viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="15"
        height="11"
        rx="0.5"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <path
        d="M3 2L2 3V9L3 10H13L14 9V3L13 2H3Z"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <circle cx="8" cy="6" r="1.5" stroke="currentColor" />
    </svg>
  )
}
